import type { FunctionComponent } from 'react';
import type { TypeOrderLineButtonsProps } from './types';

/**
 * OrderLineButtons
 */
export const OrderLineButtons: FunctionComponent<TypeOrderLineButtonsProps> = ({
  className = '',
  children,
}: TypeOrderLineButtonsProps) => (
  <div
    className={`flex h-max flex-col justify-end gap-2 xs:flex-row md:gap-4 ${className}`}
  >
    {children}
  </div>
);
